/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { GlobalPermission } from './GlobalPermission';
const PatchRoleDataParser = /* #__PURE__ */ parsers.object([
    ['permission', GlobalPermission],
    ['value', codecBoolean],
]);
export class PatchRoleData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchRoleDataParser.decode(input).map(res => new PatchRoleData(res));
    }
    static unsafeDecode(input) {
        return PatchRoleData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchRoleDataParser.encode(data);
    }
    static schema() {
        return PatchRoleDataParser.schema();
    }
}
